import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

const PersonalDetailsSection = ({
  profileData,
  setProfileData,
  userInfo,
  setUserInfo,
  showTitle = false,
  dependant = false,
  onValidityChange,
  setUnder16
}) => {
  const [underage, setUnderAge] = useState(false)

  // Validate DOB whenever it changes
  useEffect(() => {
    if (!dependant || !onValidityChange) return;

    const { day, month, year } = profileData?.date_of_birth || {}

    if (!day || !month || !year) {
      setUnder16(false)
      setUnderAge(false)
      onValidityChange(true) // invalid if any field missing
      return
    }

    const d = parseInt(day, 10)
    const m = parseInt(month, 10)
    const y = parseInt(year, 10)

    if (isNaN(d) || isNaN(m) || isNaN(y)) {
      setUnder16(false)
      setUnderAge(false)
      onValidityChange(true)
      return
    }

    const birthDate = new Date(y, m - 1, d)
    if (
      birthDate.getFullYear() !== y ||
      birthDate.getMonth() !== m - 1 ||
      birthDate.getDate() !== d
    ) {
      setUnder16(false)
      onValidityChange(false)
      return
    }

    const today = new Date()
    let age = today.getFullYear() - y
    if (today.getMonth() < m - 1 || (today.getMonth() === m - 1 && today.getDate() < d)) {
      age--
    }
    const validCheck = age < 16 // under 16 => valid
    if(validCheck)
      {
        setUnder16(true)
        setUnderAge(true)
        onValidityChange(true)
      }else{
        setUnder16(false)
        setUnderAge(false)
        onValidityChange(false)
      }
   

  }, [
    dependant,
    profileData?.date_of_birth?.day,
    profileData?.date_of_birth?.month,
    profileData?.date_of_birth?.year,
    onValidityChange
  ])

  return (
    <>
      {showTitle && (
        <div className="col-span-6">
          <div className="sm:col-span-6 border-b-2 border-b-[#DDCCDF]">
            <h2 className="text-2xl font-semibold">Profile</h2>
          </div>

          <div className="mt-4">
            <h3 className="text-lg font-medium">Personal Information</h3>
          </div>
        </div>
      )}

      {/* First Name */}
      <div className="col-span-3">
        <label htmlFor="first-name" className="block text-sm/6 font-medium">
          First name
        </label>
        <input
          id="first-name"
          name="first-name"
          value={profileData?.first_name || ''}
          onChange={(event) =>
            setProfileData((prev) => ({
              ...prev,
              first_name: event.target.value,
            }))
          }
          type="text"
          placeholder="First Name"
          autoComplete="given-name"
          className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
        />
      </div>

      {/* Last Name */}
      <div className="col-span-3">
        <label htmlFor="last-name" className="block text-sm/6 font-medium">
          Last name
        </label>
        <input
          id="last-name"
          name="last-name"
          value={profileData?.last_name || ''}
          onChange={(event) =>
            setProfileData((prev) => ({
              ...prev,
              last_name: event.target.value,
            }))
          }
          type="text"
          placeholder="Last Name"
          autoComplete="family-name"
          className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none sm:text-sm/6"
        />
      </div>

      {/* Date of Birth */}
      <div className="col-span-6">
        <label htmlFor="dob" className="block text-sm/6 font-medium">
          Date of birth
        </label>
        <div className="">
          <div className="grid grid-cols-3 gap-4 mt-2">
            <div className="flex flex-col">
              <label htmlFor="day" className="text-xs">Day</label>
              <input
                type="text"
                placeholder="11"
                value={profileData?.date_of_birth?.day || ''}
                onChange={(e) => {
                  const newDay = e.target.value
                  setProfileData((prev) => ({
                    ...prev,
                    date_of_birth: {
                      ...prev.date_of_birth,
                      day: newDay,
                    },
                  }))
                }}
                className="p-2 border rounded-lg mt-1 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none"
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="month" className="text-xs">Month</label>
              <input
                type="text"
                placeholder="10"
                value={profileData?.date_of_birth?.month || ''}
                onChange={(e) => {
                  const newMonth = e.target.value
                  setProfileData((prev) => ({
                    ...prev,
                    date_of_birth: {
                      ...prev.date_of_birth,
                      month: newMonth,
                    },
                  }))
                }}
                className="p-2 border rounded-lg mt-1 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none"
              />
            </div>
            <div className="flex flex-col">
              <label htmlFor="year" className="text-xs">Year</label>
              <input
                type="text"
                placeholder="1999"
                value={profileData?.date_of_birth?.year || ''}
                onChange={(e) => {
                  const newYear = e.target.value
                  setProfileData((prev) => ({
                    ...prev,
                    date_of_birth: {
                      ...prev.date_of_birth,
                      year: newYear,
                    },
                  }))
                }}
                className="p-2 border rounded-lg mt-1 focus:border-violet-300 focus:ring-1 focus:ring-violet-300 focus:outline-none"
              />
            </div>
          </div>

          {dependant && !underage && (
            <p className="text-red-600 text-sm mt-2">
              Dependants must be under 16. Dependants over 16 must create their
              own account.
            </p>
          )}
        </div>
      </div>

      {/* Sex */}
      {(!dependant || underage) && (
        <div className="col-span-6">
        <label htmlFor="sex" className="block text-sm/6 font-medium">
          Sex assigned at birth
        </label>
        <p className="text-sm text-slate-500">
          This refers to your sex at birth. Many problems relate specifically to
          genetically male and female organs.
        </p>
        <div className="mt-2">
          <div className="flex flex-col gap-2">
            <label className="flex items-center max-w-[100px] cursor-pointer">
              <input
                type="radio"
                name="sex"
                value="Male"
                checked={userInfo?.gender === 'Male'}
                onChange={(e) =>
                  setUserInfo((prev) => ({
                    ...prev,
                    gender: e.target.value,
                  }))
                }
                className="mr-2"
              />
              Male
            </label>
            <label className="flex items-center max-w-[100px] cursor-pointer">
              <input
                type="radio"
                name="sex"
                value="Female"
                checked={userInfo?.gender === 'Female'}
                onChange={(e) =>
                  setUserInfo((prev) => ({
                    ...prev,
                    gender: e.target.value,
                  }))
                }
                className="mr-2"
              />
              Female
            </label>
          </div>
        </div>
      </div>
      )}
    </>
  )
}

export default PersonalDetailsSection
